import { useEffect } from 'react';
import { useColorContext } from '../contexts/ColorContext';
import { usePaletteContext } from '../contexts/PaletteContext';
import { AccessibilityAuditPanel } from '../components/palette/AccessibilityAuditPanel';
import { PalettePicker } from '../components/PalettePicker';
import { useToolInit } from '../hooks/useToolInit';

export function AuditTool() {
  const { currentPalette, updateCurrentPalette, palettes, setCurrentPalette } = usePaletteContext();
  const { params } = useToolInit();

  // Deep-link: ?palette= auto-selects a palette by ID
  useEffect(() => {
    if (params.palette && !currentPalette) {
      const match = palettes.find(p => p.id === params.palette);
      if (match) setCurrentPalette(match);
    }
  }, [params.palette, palettes, currentPalette, setCurrentPalette]);

  if (!currentPalette) {
    return <PalettePicker prompt="Select a palette to run an accessibility audit." />;
  }

  return (
    <div className="w-full max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">
        Palette Audit — {currentPalette.name}
      </h2>
      <AccessibilityAuditPanel
        palette={currentPalette}
        onUpdatePalette={updateCurrentPalette}
      />
    </div>
  );
}
